import { useEffect, useState } from 'react'
import QRCode from 'qrcode'

interface QrCodeProps {
  value: string
  /** Boks-størrelse i px (96-160). */
  size?: number
  className?: string
}

function QrCode({ value, size = 120, className = '' }: QrCodeProps) {
  const [svg, setSvg] = useState('')

  useEffect(() => {
    let cancelled = false
    QRCode.toString(value, { type: 'svg', margin: 1, color: { dark: '#10161a', light: '#fbf5e6' } })
      .then((markup) => {
        if (!cancelled) setSvg(markup)
      })
      .catch(() => {
        if (!cancelled) setSvg('')
      })
    return () => {
      cancelled = true
    }
  }, [value])

  return (
    <div
      className={`grid flex-none place-items-center rounded-[10px] bg-cream p-2 ${className}`}
      style={{ width: size, height: size }}
      dangerouslySetInnerHTML={{ __html: svg }}
      aria-label="QR-kode til invitation"
      role="img"
    />
  )
}

export default QrCode
